import type { ISerialize } from '@/objects/ISerialize';
import { ContestantImportRelayContestant } from './ContestantImportRelayContestant';
import type { Gender } from './../enums/Gender';
import { formatDateIso } from '@/utilities/dateutils';

export class ContestantImportRow implements ISerialize {
    public ID: number;

    public Birthday: string | null;

    public BirthdayNormalized: string | null;

    public BuypassID: string | null;

    public Category: string | null;

    public Cellphone: string | null;

    public Chip1: string | null;

    public Chip2: string | null;

    public Club: string | null;

    public Company: string | null;

    public ContestantStatusID: number | null;

    public CountryId: string | null;

    public Day: number | null;

    public DBErrors: string | null;

    public DBMessages: string | null;

    public DBWarnings: string | null;

    public Email: string | null;

    public EmitID: string | null;

    public EventTeamId: number | null;

    public EventTeamName: string | null;

    public Extra1: string | null;

    public Extra2: string | null;

    public Extra3: string | null;

    public Extra4: string | null;

    public Extra5: string | null;

    public Firstname: string | null;

    public FISID: string | null;

    public FullnameFirstFirst: string | null;

    public FullnameLastFirst: string | null;

    public Gender: string | null;

    public GenderNormalized: Gender | null;

    public Group: string | null;

    public ISonenID: string | null;

    public LegNumber: string | null;

    public Month: number | null;

    public Nationality: string | null;

    public NationalityNormalized: number | null;

    public NIFID: string | null;

    public PersonNumber: string | null;

    public PostAddress1: string | null;

    public PostAddress2: string | null;

    public PostCity: string | null;

    public PostZipCode: string | null;

    public Race: string | null;

    public Rank: string | null;

    public RegistrarEmail: string | null;

    public RegistrarFirstname: string | null;

    public RegistrarSurname: string | null;

    public RelayTeamName: string | null;

    public Resultpoint: string | null;

    public ResultTime: string | null;

    public ResultTimeNormalized: Date | null;

    public Seeding: number | null;

    public SourceCategoryId: number | null;

    public SourceClubId: number | null;

    public SourceContestantId: number | null;

    public SourceGroupId: number | null;

    public SourceParticipantId: number | null;

    public SourceRelayTeamContestants: ContestantImportRelayContestant[];

    public SourceSAClubId: number | null;

    public SourceSATeamId: number | null;

    public SourceTeamId: number | null;

    public Startnumber: string | null;

    public Starttime: string | null;

    public StarttimeNormalized: Date | null;

    public Surname: string | null;

    public TeamName: string | null;

    public Telephone: string | null;

    public Year: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Birthday?: string | null;
        BirthdayNormalized?: string | null;
        BuypassID?: string | null;
        Category?: string | null;
        Cellphone?: string | null;
        Chip1?: string | null;
        Chip2?: string | null;
        Club?: string | null;
        Company?: string | null;
        ContestantStatusID?: number | null;
        CountryId?: string | null;
        Day?: number | null;
        DBErrors?: string | null;
        DBMessages?: string | null;
        DBWarnings?: string | null;
        Email?: string | null;
        EmitID?: string | null;
        EventTeamId?: number | null;
        EventTeamName?: string | null;
        Extra1?: string | null;
        Extra2?: string | null;
        Extra3?: string | null;
        Extra4?: string | null;
        Extra5?: string | null;
        Firstname?: string | null;
        FISID?: string | null;
        FullnameFirstFirst?: string | null;
        FullnameLastFirst?: string | null;
        Gender?: string | null;
        GenderNormalized?: Gender | null;
        Group?: string | null;
        ISonenID?: string | null;
        LegNumber?: string | null;
        Month?: number | null;
        Nationality?: string | null;
        NationalityNormalized?: number | null;
        NIFID?: string | null;
        PersonNumber?: string | null;
        PostAddress1?: string | null;
        PostAddress2?: string | null;
        PostCity?: string | null;
        PostZipCode?: string | null;
        Race?: string | null;
        Rank?: string | null;
        RegistrarEmail?: string | null;
        RegistrarFirstname?: string | null;
        RegistrarSurname?: string | null;
        RelayTeamName?: string | null;
        Resultpoint?: string | null;
        ResultTime?: string | null;
        ResultTimeNormalized?: Date | null;
        Seeding?: number | null;
        SourceCategoryId?: number | null;
        SourceClubId?: number | null;
        SourceContestantId?: number | null;
        SourceGroupId?: number | null;
        SourceParticipantId?: number | null;
        SourceRelayTeamContestants?: ContestantImportRelayContestant[];
        SourceSAClubId?: number | null;
        SourceSATeamId?: number | null;
        SourceTeamId?: number | null;
        Startnumber?: string | null;
        Starttime?: string | null;
        StarttimeNormalized?: Date | null;
        Surname?: string | null;
        TeamName?: string | null;
        Telephone?: string | null;
        Year?: number | null;
    }) {
        this.ID = values.ID ?? 0;

        this.Birthday = values.Birthday ?? '';

        this.BirthdayNormalized = values.BirthdayNormalized ?? null;

        this.BuypassID = values.BuypassID ?? '';

        this.Category = values.Category ?? '';

        this.Cellphone = values.Cellphone ?? '';

        this.Chip1 = values.Chip1 ?? '';

        this.Chip2 = values.Chip2 ?? '';

        this.Club = values.Club ?? '';

        this.Company = values.Company ?? '';

        this.ContestantStatusID = values.ContestantStatusID ?? null;

        this.CountryId = values.CountryId ?? '';

        this.Day = values.Day ?? null;

        this.DBErrors = values.DBErrors ?? '';

        this.DBMessages = values.DBMessages ?? '';

        this.DBWarnings = values.DBWarnings ?? '';

        this.Email = values.Email ?? '';

        this.EmitID = values.EmitID ?? '';

        this.EventTeamId = values.EventTeamId ?? null;

        this.EventTeamName = values.EventTeamName ?? '';

        this.Extra1 = values.Extra1 ?? '';

        this.Extra2 = values.Extra2 ?? '';

        this.Extra3 = values.Extra3 ?? '';

        this.Extra4 = values.Extra4 ?? '';

        this.Extra5 = values.Extra5 ?? '';

        this.Firstname = values.Firstname ?? '';

        this.FISID = values.FISID ?? '';

        this.FullnameFirstFirst = values.FullnameFirstFirst ?? '';

        this.FullnameLastFirst = values.FullnameLastFirst ?? '';

        this.Gender = values.Gender ?? '';

        this.GenderNormalized = values.GenderNormalized ?? 'm';

        this.Group = values.Group ?? '';

        this.ISonenID = values.ISonenID ?? null;

        this.LegNumber = values.LegNumber ?? '';

        this.Month = values.Month ?? null;

        this.Nationality = values.Nationality ?? '';

        this.NationalityNormalized = values.NationalityNormalized ?? null;

        this.NIFID = values.NIFID ?? '';

        this.PersonNumber = values.PersonNumber ?? '';

        this.PostAddress1 = values.PostAddress1 ?? '';

        this.PostAddress2 = values.PostAddress2 ?? '';

        this.PostCity = values.PostCity ?? '';

        this.PostZipCode = values.PostZipCode ?? '';

        this.Race = values.Race ?? '';

        this.Rank = values.Rank ?? '';

        this.RegistrarEmail = values.RegistrarEmail ?? '';

        this.RegistrarFirstname = values.RegistrarFirstname ?? '';

        this.RegistrarSurname = values.RegistrarSurname ?? '';

        this.RelayTeamName = values.RelayTeamName ?? '';

        this.Resultpoint = values.Resultpoint ?? '';

        this.ResultTime = values.ResultTime ?? '';

        this.ResultTimeNormalized = values.ResultTimeNormalized ?? null;

        this.Seeding = values.Seeding ?? null;

        this.SourceCategoryId = values.SourceCategoryId ?? null;

        this.SourceClubId = values.SourceClubId ?? null;

        this.SourceContestantId = values.SourceContestantId ?? null;

        this.SourceGroupId = values.SourceGroupId ?? null;

        this.SourceParticipantId = values.SourceParticipantId ?? null;

        this.SourceRelayTeamContestants = values.SourceRelayTeamContestants ?? [];

        this.SourceSAClubId = values.SourceSAClubId ?? null;

        this.SourceSATeamId = values.SourceSATeamId ?? null;

        this.SourceTeamId = values.SourceTeamId ?? null;

        this.Startnumber = values.Startnumber ?? '';

        this.Starttime = values.Starttime ?? '';

        this.StarttimeNormalized = values.StarttimeNormalized ?? null;

        this.Surname = values.Surname ?? '';

        this.TeamName = values.TeamName ?? '';

        this.Telephone = values.Telephone ?? '';

        this.Year = values.Year ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Birthday": ${JSON.stringify(this.Birthday)}` +
            ',' +
            `"BirthdayNormalized": ${JSON.stringify(this.BirthdayNormalized)}` +
            ',' +
            `"BuypassID": ${JSON.stringify(this.BuypassID)}` +
            ',' +
            `"Category": ${JSON.stringify(this.Category)}` +
            ',' +
            `"Cellphone": ${JSON.stringify(this.Cellphone)}` +
            ',' +
            `"Chip1": ${JSON.stringify(this.Chip1)}` +
            ',' +
            `"Chip2": ${JSON.stringify(this.Chip2)}` +
            ',' +
            `"Club": ${JSON.stringify(this.Club)}` +
            ',' +
            `"Company": ${JSON.stringify(this.Company)}` +
            ',' +
            `"ContestantStatusID": ${JSON.stringify(this.ContestantStatusID)}` +
            ',' +
            `"CountryId": ${JSON.stringify(this.CountryId)}` +
            ',' +
            `"Day": ${JSON.stringify(this.Day)}` +
            ',' +
            `"DBErrors": ${JSON.stringify(this.DBErrors)}` +
            ',' +
            `"DBMessages": ${JSON.stringify(this.DBMessages)}` +
            ',' +
            `"DBWarnings": ${JSON.stringify(this.DBWarnings)}` +
            ',' +
            `"Email": ${JSON.stringify(this.Email)}` +
            ',' +
            `"EmitID": ${JSON.stringify(this.EmitID)}` +
            ',' +
            `"EventTeamId": ${JSON.stringify(this.EventTeamId)}` +
            ',' +
            `"EventTeamName": ${JSON.stringify(this.EventTeamName)}` +
            ',' +
            `"Extra1": ${JSON.stringify(this.Extra1)}` +
            ',' +
            `"Extra2": ${JSON.stringify(this.Extra2)}` +
            ',' +
            `"Extra3": ${JSON.stringify(this.Extra3)}` +
            ',' +
            `"Extra4": ${JSON.stringify(this.Extra4)}` +
            ',' +
            `"Extra5": ${JSON.stringify(this.Extra5)}` +
            ',' +
            `"Firstname": ${JSON.stringify(this.Firstname)}` +
            ',' +
            `"FISID": ${JSON.stringify(this.FISID)}` +
            ',' +
            `"FullnameFirstFirst": ${JSON.stringify(this.FullnameFirstFirst)}` +
            ',' +
            `"FullnameLastFirst": ${JSON.stringify(this.FullnameLastFirst)}` +
            ',' +
            `"Gender": ${JSON.stringify(this.Gender)}` +
            ',' +
            `"GenderNormalized": ${this.GenderNormalized == null ? null : this.GenderNormalized == 'm' ? 0 : this.GenderNormalized == 'f' ? 1 : this.GenderNormalized == 'n' ? 2 : null}` +
            ',' +
            `"Group": ${JSON.stringify(this.Group)}` +
            ',' +
            `"ISonenID": ${JSON.stringify(this.ISonenID)}` +
            ',' +
            `"LegNumber": ${JSON.stringify(this.LegNumber)}` +
            ',' +
            `"Month": ${JSON.stringify(this.Month)}` +
            ',' +
            `"Nationality": ${JSON.stringify(this.Nationality)}` +
            ',' +
            `"NationalityNormalized": ${JSON.stringify(this.NationalityNormalized)}` +
            ',' +
            `"NIFID": ${JSON.stringify(this.NIFID)}` +
            ',' +
            `"PersonNumber": ${JSON.stringify(this.PersonNumber)}` +
            ',' +
            `"PostAddress1": ${JSON.stringify(this.PostAddress1)}` +
            ',' +
            `"PostAddress2": ${JSON.stringify(this.PostAddress2)}` +
            ',' +
            `"PostCity": ${JSON.stringify(this.PostCity)}` +
            ',' +
            `"PostZipCode": ${JSON.stringify(this.PostZipCode)}` +
            ',' +
            `"Race": ${JSON.stringify(this.Race)}` +
            ',' +
            `"Rank": ${JSON.stringify(this.Rank)}` +
            ',' +
            `"RegistrarEmail": ${JSON.stringify(this.RegistrarEmail)}` +
            ',' +
            `"RegistrarFirstname": ${JSON.stringify(this.RegistrarFirstname)}` +
            ',' +
            `"RegistrarSurname": ${JSON.stringify(this.RegistrarSurname)}` +
            ',' +
            `"RelayTeamName": ${JSON.stringify(this.RelayTeamName)}` +
            ',' +
            `"Resultpoint": ${JSON.stringify(this.Resultpoint)}` +
            ',' +
            `"ResultTime": ${JSON.stringify(this.ResultTime)}` +
            ',' +
            `"ResultTimeNormalized": ${this.ResultTimeNormalized ? '"' + formatDateIso(this.ResultTimeNormalized) + '"' : null}` +
            ',' +
            `"Seeding": ${JSON.stringify(this.Seeding)}` +
            ',' +
            `"SourceCategoryId": ${JSON.stringify(this.SourceCategoryId)}` +
            ',' +
            `"SourceClubId": ${JSON.stringify(this.SourceClubId)}` +
            ',' +
            `"SourceContestantId": ${JSON.stringify(this.SourceContestantId)}` +
            ',' +
            `"SourceGroupId": ${JSON.stringify(this.SourceGroupId)}` +
            ',' +
            `"SourceParticipantId": ${JSON.stringify(this.SourceParticipantId)}` +
            ',' +
            `"SourceRelayTeamContestants": [ ${this.SourceRelayTeamContestants.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"SourceSAClubId": ${JSON.stringify(this.SourceSAClubId)}` +
            ',' +
            `"SourceSATeamId": ${JSON.stringify(this.SourceSATeamId)}` +
            ',' +
            `"SourceTeamId": ${JSON.stringify(this.SourceTeamId)}` +
            ',' +
            `"Startnumber": ${JSON.stringify(this.Startnumber)}` +
            ',' +
            `"Starttime": ${JSON.stringify(this.Starttime)}` +
            ',' +
            `"StarttimeNormalized": ${this.StarttimeNormalized ? '"' + formatDateIso(this.StarttimeNormalized) + '"' : null}` +
            ',' +
            `"Surname": ${JSON.stringify(this.Surname)}` +
            ',' +
            `"TeamName": ${JSON.stringify(this.TeamName)}` +
            ',' +
            `"Telephone": ${JSON.stringify(this.Telephone)}` +
            ',' +
            `"Year": ${JSON.stringify(this.Year)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ContestantImportRow from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Birthday?: string | null;
        BirthdayNormalized?: string | null;
        BuypassID?: string | null;
        Category?: string | null;
        Cellphone?: string | null;
        Chip1?: string | null;
        Chip2?: string | null;
        Club?: string | null;
        Company?: string | null;
        ContestantStatusID?: number | null;
        CountryId?: string | null;
        Day?: number | null;
        DBErrors?: string | null;
        DBMessages?: string | null;
        DBWarnings?: string | null;
        Email?: string | null;
        EmitID?: string | null;
        EventTeamId?: number | null;
        EventTeamName?: string | null;
        Extra1?: string | null;
        Extra2?: string | null;
        Extra3?: string | null;
        Extra4?: string | null;
        Extra5?: string | null;
        Firstname?: string | null;
        FISID?: string | null;
        FullnameFirstFirst?: string | null;
        FullnameLastFirst?: string | null;
        Gender?: string | null;
        GenderNormalized?: Gender | null;
        Group?: string | null;
        ISonenID?: string | null;
        LegNumber?: string | null;
        Month?: number | null;
        Nationality?: string | null;
        NationalityNormalized?: number | null;
        NIFID?: string | null;
        PersonNumber?: string | null;
        PostAddress1?: string | null;
        PostAddress2?: string | null;
        PostCity?: string | null;
        PostZipCode?: string | null;
        Race?: string | null;
        Rank?: string | null;
        RegistrarEmail?: string | null;
        RegistrarFirstname?: string | null;
        RegistrarSurname?: string | null;
        RelayTeamName?: string | null;
        Resultpoint?: string | null;
        ResultTime?: string | null;
        ResultTimeNormalized?: Date | null;
        Seeding?: number | null;
        SourceCategoryId?: number | null;
        SourceClubId?: number | null;
        SourceContestantId?: number | null;
        SourceGroupId?: number | null;
        SourceParticipantId?: number | null;
        SourceRelayTeamContestants?: ContestantImportRelayContestant[];
        SourceSAClubId?: number | null;
        SourceSATeamId?: number | null;
        SourceTeamId?: number | null;
        Startnumber?: string | null;
        Starttime?: string | null;
        StarttimeNormalized?: Date | null;
        Surname?: string | null;
        TeamName?: string | null;
        Telephone?: string | null;
        Year?: number | null;
    }): ContestantImportRow {
        return new ContestantImportRow(values);
    }

    public static _FromServerJson(json: any): ContestantImportRow {
        return new ContestantImportRow({
            ID: json.ID,
            Birthday: json.Birthday ?? '',
            BirthdayNormalized: json.BirthdayNormalized ?? '',
            BuypassID: json.BuypassID ?? '',
            Category: json.Category ?? '',
            Cellphone: json.Cellphone ?? '',
            Chip1: json.Chip1 ?? '',
            Chip2: json.Chip2 ?? '',
            Club: json.Club ?? '',
            Company: json.Company ?? '',
            ContestantStatusID: json.ContestantStatusID ?? null,
            CountryId: json.CountryId ?? '',
            Day: json.Day ?? null,
            DBErrors: json.DBErrors ?? '',
            DBMessages: json.DBMessages ?? '',
            DBWarnings: json.DBWarnings ?? '',
            Email: json.Email ?? '',
            EmitID: json.EmitID ?? '',
            EventTeamId: json.EventTeamId ?? null,
            EventTeamName: json.EventTeamName ?? '',
            Extra1: json.Extra1 ?? '',
            Extra2: json.Extra2 ?? '',
            Extra3: json.Extra3 ?? '',
            Extra4: json.Extra4 ?? '',
            Extra5: json.Extra5 ?? '',
            Firstname: json.Firstname ?? '',
            FISID: json.FISID ?? '',
            FullnameFirstFirst: json.FullnameFirstFirst ?? '',
            FullnameLastFirst: json.FullnameLastFirst ?? '',
            Gender: json.Gender ?? '',
            GenderNormalized:
                json.GenderNormalized == null
                    ? null
                    : json.GenderNormalized == 0
                      ? 'm'
                      : json.GenderNormalized == 1
                        ? 'f'
                        : json.GenderNormalized == 2
                          ? 'n'
                          : null,
            Group: json.Group ?? '',
            ISonenID: json.ISonenID ?? '',
            LegNumber: json.LegNumber ?? '',
            Month: json.Month ?? null,
            Nationality: json.Nationality ?? '',
            NationalityNormalized: json.NationalityNormalized ?? null,
            NIFID: json.NIFID ?? '',
            PersonNumber: json.PersonNumber ?? '',
            PostAddress1: json.PostAddress1 ?? '',
            PostAddress2: json.PostAddress2 ?? '',
            PostCity: json.PostCity ?? '',
            PostZipCode: json.PostZipCode ?? '',
            Race: json.Race ?? '',
            Rank: json.Rank ?? '',
            RegistrarEmail: json.RegistrarEmail ?? '',
            RegistrarFirstname: json.RegistrarFirstname ?? '',
            RegistrarSurname: json.RegistrarSurname ?? '',
            RelayTeamName: json.RelayTeamName ?? '',
            Resultpoint: json.Resultpoint ?? '',
            ResultTime: json.ResultTime ?? '',
            ResultTimeNormalized: json.ResultTimeNormalized
                ? json.ResultTimeNormalized instanceof Date
                    ? json.ResultTimeNormalized
                    : new Date(json.ResultTimeNormalized)
                : null,
            Seeding: json.Seeding ?? null,
            SourceCategoryId: json.SourceCategoryId ?? null,
            SourceClubId: json.SourceClubId ?? null,
            SourceContestantId: json.SourceContestantId ?? null,
            SourceGroupId: json.SourceGroupId ?? null,
            SourceParticipantId: json.SourceParticipantId ?? null,
            SourceRelayTeamContestants: json.SourceRelayTeamContestants?.map((x: any) =>
                ContestantImportRelayContestant._FromServerJson(x),
            ),
            SourceSAClubId: json.SourceSAClubId ?? null,
            SourceSATeamId: json.SourceSATeamId ?? null,
            SourceTeamId: json.SourceTeamId ?? null,
            Startnumber: json.Startnumber ?? '',
            Starttime: json.Starttime ?? '',
            StarttimeNormalized: json.StarttimeNormalized
                ? json.StarttimeNormalized instanceof Date
                    ? json.StarttimeNormalized
                    : new Date(json.StarttimeNormalized)
                : null,
            Surname: json.Surname ?? '',
            TeamName: json.TeamName ?? '',
            Telephone: json.Telephone ?? '',
            Year: json.Year ?? null,
        });
    }

    /**
     * Creates an instance of ContestantImportRow from another instance of ContestantImportRow.
     * @param other The ContestantImportRow you want to clone
     * @returns A cloned ContestantImportRow
     */
    public static FromOther(other: ContestantImportRow): ContestantImportRow {
        return ContestantImportRow._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ContestantImportRow.FromOther(this);
    }

    static NAME_OF_CLASS = 'ContestantImportRow';
}
